<template>
  <div style="display: none"></div>
</template>

<script>
import Request from "../../request/request";
import { changeLogPath } from "../../router/ApiPaths";
import Cookies from "js-cookie";
import { mapGetters } from "vuex";
import { openPopupTipScreen } from "../map/popup";

export default {
  name: "InfoControl",
  extends: Request,
  data() {
    return {
      page: null,
    };
  },
  computed: {
    ...mapGetters({
      isLogged: "isLogged",
    }),
  },
  watch: {
    isLogged(newValue) {
      if (newValue) this.checkAndOpen();
    },
  },
  methods: {
    checkAndOpen() {
      this.get(changeLogPath, null, true).then((data) => {
        if (data && data.id) {
          this.page = data;
          const screenVisualized = Cookies.get("screenVisualized");
          if (screenVisualized != "" + this.page.id) {
            openPopupTipScreen(this.page);
          }
        }
      });
    },
  },
  mounted() {
    if (this.isLogged) this.checkAndOpen();
  },
};
</script>
